import { render, staticRenderFns } from "./WistiaPlayer.vue?vue&type=template&id=63b9bfb3"
import script from "./WistiaPlayer.vue?vue&type=script&lang=js"
export * from "./WistiaPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports